module.exports = __webpack_public_path__ + "img/01：GT-1.9d975b0a.jpg";